/**
 * form の値を送信用の値に変換する
 */
export const getHotlineProFirstReplySubmitValues = (formValue) => (Object.assign(Object.assign({}, formValue), { other: formValue.other || null, similar_project: formValue.similarProject }));
